import { render } from "./ButtonCount.vue?vue&type=template&id=13a259b4&scoped=true&ts=true"
import script from "./ButtonCount.vue?vue&type=script&lang=ts"
export * from "./ButtonCount.vue?vue&type=script&lang=ts"

import "./ButtonCount.vue?vue&type=style&index=0&id=13a259b4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a259b4"]])

export default __exports__